"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLiffCreateOrderModel = instanceOfLiffCreateOrderModel;
exports.LiffCreateOrderModelFromJSON = LiffCreateOrderModelFromJSON;
exports.LiffCreateOrderModelFromJSONTyped = LiffCreateOrderModelFromJSONTyped;
exports.LiffCreateOrderModelToJSON = LiffCreateOrderModelToJSON;
exports.LiffCreateOrderModelToJSONTyped = LiffCreateOrderModelToJSONTyped;
/**
 * Check if a given object implements the LiffCreateOrderModel interface.
 */
function instanceOfLiffCreateOrderModel(value) {
    return true;
}
function LiffCreateOrderModelFromJSON(json) {
    return LiffCreateOrderModelFromJSONTyped(json, false);
}
function LiffCreateOrderModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lineId': json['lineId'] == null ? undefined : json['lineId'],
        'lineName': json['lineName'] == null ? undefined : json['lineName'],
        'frameNos': json['frameNos'] == null ? undefined : json['frameNos'],
        'promotionNo': json['promotionNo'] == null ? undefined : json['promotionNo'],
        'qrData': json['qrData'] == null ? undefined : json['qrData'],
        'imageJson': json['imageJson'] == null ? undefined : json['imageJson'],
        'partnerOrgId': json['partnerOrgId'] == null ? undefined : json['partnerOrgId'],
        'partnerName': json['partnerName'] == null ? undefined : json['partnerName'],
    };
}
function LiffCreateOrderModelToJSON(json) {
    return LiffCreateOrderModelToJSONTyped(json, false);
}
function LiffCreateOrderModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'lineId': value['lineId'],
        'lineName': value['lineName'],
        'frameNos': value['frameNos'],
        'promotionNo': value['promotionNo'],
        'qrData': value['qrData'],
        'imageJson': value['imageJson'],
        'partnerOrgId': value['partnerOrgId'],
        'partnerName': value['partnerName'],
    };
}
